import { Button } from "~/components/ui/button";
import { Row } from "~/components/ui/stack";
import { Text } from "~/components/ui/text";

type FilterPopoverHeaderProps = {
  onReset: () => void;
  onClear?: () => void;
};

export const FilterPopoverHeader = ({
  onReset,
  onClear,
}: FilterPopoverHeaderProps) => {
  return (
    <Row
      justify="space-between"
      align="center"
      paddingBottom="small"
      marginBottom="large"
      borderBottom="standard"
      borderBottomWidth="medium"
    >
      <Text size="large" weight="medium">
        Filters
      </Text>
      {onClear ? (
        <Button variant="link" onClick={onClear}>
          Clear Filters
        </Button>
      ) : null}
      <Button variant="link" onClick={onReset}>
        Reset Filters
      </Button>
    </Row>
  );
};
